(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jil", [], factory);
	else if(typeof exports === 'object')
		exports["jil"] = factory();
	else
		root["jil"] = factory();
})(window, function() {
return 